import { CONSENT } from '../types/consent';
import { GTMAdapter } from './GTMAdapter';
import { Optimizely } from './OptimizelyAdapter';
/**
 * List of all supported platform adapters
 */
export var AdapterMap = {
    Optimizely: Optimizely,
    GTM: new GTMAdapter(),
    Heap: new GTMAdapter('heap', CONSENT.PERFORMANCE, GTMAdapter.payloadConverter.params)
};
